import { HeadlineVariation } from '@allesauto/utils/consts';
import { Email20 } from '@carbon/icons-react';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

import Button from '../button';
import Headline from '../headline';

export interface ISimpleContactForm {
  title: string;
  headline: string;
  buttonText: string;
  emailToSend: string;
  footline?: string;
  component: string;
  _uid: string;
  _editable?: string;
}

const SimpleContactForm: FC<ISimpleContactForm> = (props) => {
  const { title, headline, buttonText, emailToSend, footline } = props;

  const buttonAction = (email: string) => {
    window.location.href = 'mailto:' + email;
  };

  const cssClass = {
    container: 'bg-purple80 lg:min-h-[calc(100vh-690px)] monochrome:bg-grey90',
    wrapperClass: clsx(
      'grid grid-cols-24 sm:pt-40px lg:pt-[95px]',
      !footline && 'pb-[245px]'
    ),
    headlineClass:
      'sm:col-start-2 sm:col-end-24 lg:col-start-5 lg:col-end-21 text-center',
    textClass:
      'sm:col-start-3 sm:col-end-23 lg:col-start-9 lg:col-end-17 text-white text-center pt-20px sm:pb-[52px] lg:pb-40px',
    buttonClass: 'sm:col-start-3 sm:col-end-23 lg:col-start-11 lg:col-end-15',
    footlineClass: clsx(
      'text-center sm:col-end-23 sm:col-start-3 sm:pb-80px sm:pt-[75px] lg:col-end-17 lg:col-start-9 lg:pb-[110px] lg:pt-[90px]',
      'text-white monochrome:text-white'
    ),
  };

  return (
    <div {...sbEditable(props)} className={cssClass.container}>
      <div className={cssClass.wrapperClass}>
        <div className={cssClass.headlineClass}>
          <Headline
            headlineText={title}
            headlineTag={HeadlineVariation.H1}
            headlineColor="text-white"
          />
        </div>
        <div className={cssClass.textClass}>{headline}</div>
        <Button
          icon={<Email20 className="mr-10px" />}
          text={buttonText}
          customClassName={cssClass.buttonClass}
          whitelabel={true}
          onClick={() => buttonAction(emailToSend)}
        />
        {footline && <div className={cssClass.footlineClass}>{footline}</div>}
      </div>
    </div>
  );
};

export default SimpleContactForm;
